import { option_timestream_privacy_title } from './TimeStreamPrivacyOption.locstring.json';
import { createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isOutlookSpacesEnabled } from 'owa-timestream-enabled';

export default createLazyOption(
    {
        key: 'timestream_privacy_export',
        titleStringKey: option_timestream_privacy_title,
        searchTermsStringKey: option_timestream_privacy_title,
        isHidden: () => !isOutlookSpacesEnabled(),
    },
    new LazyModule(() => import('./lazyFullOption')),
    m => m.default
);
